import H5 from "@material-tailwind/react/Heading5";
import LeadText from "@material-tailwind/react/LeadText";
import Icon from "@material-tailwind/react/Icon";
import preval from "preval.macro";
import {Link} from "react-router-dom";

export default function DefaultFooter() {
  return (
    <>
      <footer className="relative bg-gray-100 pt-8 pb-6">
        <div className="container max-w-7xl mx-auto px-4">
          <div className="flex flex-wrap text-center lg:text-left pt-6">
            <div className="w-full lg:w-6/12 px-4">
              <H5 color="gray">SquareHunters.com</H5>
              <div className="-mt-4">
                <LeadText color="blueGray"></LeadText>
              </div>
              <div className="flex gap-2 mt-6 md:justify-start md:mb-0 mb-8 justify-center">
                {/*<a*/}
                {/*    href="https://www.facebook.com/CreativeTim"*/}
                {/*    className="grid place-items-center bg-white text-blue-600 shadow-md font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none"*/}
                {/*    target="_blank"*/}
                {/*    rel="noopener noreferrer"*/}
                {/*>*/}
                {/*    <Icon*/}
                {/*        family="font-awesome"*/}
                {/*        name="fab fa-facebook-square"*/}
                {/*    />*/}
                {/*</a>*/}
                <a
                  href="https://twitter.com/cexar_"
                  className="grid place-items-center bg-white text-blue-400 shadow-md font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon family="font-awesome" name="fab fa-twitter" />
                </a>
                {/*<a*/}
                {/*    href="https://www.instagram.com/creativetimofficial/"*/}
                {/*    className="grid place-items-center bg-white text-indigo-500 shadow-md font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none"*/}
                {/*    target="_blank"*/}
                {/*    rel="noopener noreferrer"*/}
                {/*>*/}
                {/*    <Icon*/}
                {/*        family="font-awesome"*/}
                {/*        name="fab fa-instagram"*/}
                {/*    />*/}
                {/*</a>*/}
                <a
                  href="https://www.strava.com/athletes/cexar"
                  className="grid place-items-center bg-white text-pink-400 shadow-md font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon family="font-awesome" name="fab fa-strava" />
                </a>
                {/*<a*/}
                {/*    href="https://www.youtube.com/channel/UCVyTG4sCw-rOvB9oHkzZD1w"*/}
                {/*    className="grid place-items-center bg-white text-red-600 shadow-md font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none"*/}
                {/*    target="_blank"*/}
                {/*    rel="noopener noreferrer"*/}
                {/*>*/}
                {/*    <Icon*/}
                {/*        family="font-awesome"*/}
                {/*        name="fab fa-youtube"*/}
                {/*    />*/}
                {/*</a>*/}
                <a
                  href="https://github.com/cgorka"
                  className="grid place-items-center bg-white text-gray-900 shadow-md font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon family="font-awesome" name="fab fa-github" />
                </a>
                <div className="text-sm text-gray-700 font-medium py-2">
                  <p>
                    <small>Knowledge should be  free. </small>
                  </p>
                  <p>
                    <small>From Poland with 💗</small>
                  </p>
                  <p>
                    <small>
                      Build Date:{" "}
                      {preval`module.exports = new Date().toLocaleString();`}.
                      {" "}
                    </small>
                  </p>
                  <small>
                    <a href="http://cexar.it" target="_blank">
                    by ceXar.it
                    </a>
                  </small>
                  <p>
                  <small>
                    <a href="http://rx48.eu" target="_blank">
                      powered by rx48.eu group
                    </a>
                  </small>
                  </p>

                </div>
              </div>
            </div>
            <div className="flex flex-wrap items-center md:justify-between justify-center">
              <div></div>
            </div>
            <div className="w-full lg:w-6/12 px-4">
              <div className="flex flex-wrap items-top">
                <div className="w-full lg:w-4/12 px-4 ml-auto md:mb-0 mb-8">
                  <span className="block uppercase text-gray-900 text-sm font-serif font-medium mb-2">
                    Useful Links
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        href="http://rx48.eu"
                        target="_blank"
                        rel="noreferrer"
                        className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.strava.com/athletes/cexar"
                        target="_blank"
                        rel="noreferrer"
                        className="text-gray-700 hover:text-gray-900 block pb-2 text-sm about "
                      >
                        Me on Strava
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://twitter.com/cexar_"
                        target="_blank"
                        rel="noreferrer"
                        className="text-gray-700 hover:text-gray-900 block pb-2 text-sm about "
                      >
                        Me on Twitter
                      </a>
                    </li>
                    <li>
                      <a
                          href="https://www.strava.com/clubs/squarehunters"
                          target="_blank"
                          rel="noreferrer"
                          className="text-gray-700 hover:text-gray-900 block pb-2 text-sm about "
                      >
                       Strava Club
                      </a>
                    </li>
                    <li>
                      <Link to="/privacyPolicy">
                       <div                           className="text-gray-700 hover:text-gray-900 block pb-2 text-sm about "
                       > Privacy Policy</div>
                      </Link>
                    </li>
                    {/*<li>*/}
                    {/*    <a href=""  className="about"*/}
                    {/*       title="ceXar at Strava" >*/}
                    {/*        <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"*/}
                    {/*             className="icon strava"><title>Stan Ansems at Strava</title>*/}
                    {/*            <path*/}
                    {/*                d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169"></path>*/}
                    {/*        </svg>*/}
                    {/*         Strava</a>*/}
                    {/*</li>*/}
                    <small>
                      Here is no adds (and never will be) please consider small
                      donation to get all the servers up and running{" "}
                    </small>
                    <a href="https://ko-fi.com/E1E26J6RH" target="_blank">
                      <img
                        height="36"
                        src="https://cdn.ko-fi.com/cdn/kofi2.png?v=3"
                        border="0"
                        alt="Buy Me a Coffee at ko-fi.com"
                      />
                    </a>


                    {/*<li>*/}
                    {/*    <a*/}
                    {/*        className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"*/}
                    {/*        target="_blank"*/}
                    {/*        href=" https://www.creative-tim.com/blog?ref=mtk"*/}
                    {/*    >*/}
                    {/*        Blog*/}
                    {/*    </a>*/}
                    {/*</li>*/}
                    {/*<li>*/}
                    {/*    <a*/}
                    {/*        href="https://www.github.com/creativetimofficial?ref=mtk"*/}
                    {/*        target="_blank"*/}
                    {/*        rel="noreferrer"*/}
                    {/*        className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"*/}
                    {/*    >*/}
                    {/*        Github*/}
                    {/*    </a>*/}
                    {/*</li>*/}
                    {/*<li>*/}
                    {/*    <a*/}
                    {/*        href=" https://www.creative-tim.com/templates/free?ref=mtk"*/}
                    {/*        target="_blank"*/}
                    {/*        rel="noreferrer"*/}
                    {/*        className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"*/}
                    {/*    >*/}
                    {/*        Free Products*/}
                    {/*    </a>*/}
                    {/*</li>*/}
                  </ul>
                </div>
                {/*<div className="w-full lg:w-4/12 px-4">*/}
                {/*    <span className="block uppercase text-gray-900 text-sm font-serif font-medium mb-2">*/}
                {/*        Other Resources*/}
                {/*    </span>*/}
                {/*    <ul className="list-unstyled">*/}
                {/*        <li>*/}
                {/*            <a*/}
                {/*                href="https://github.com/creativetimofficial/material-tailwind/blob/main/LICENSE.md?ref=mtk"*/}
                {/*                target="_blank"*/}
                {/*                rel="noreferrer"*/}
                {/*                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"*/}
                {/*            >*/}
                {/*                MIT License*/}
                {/*            </a>*/}
                {/*        </li>*/}
                {/*        <li>*/}
                {/*            <a*/}
                {/*                href="https://github.com/creativetimofficial/material-tailwind/blob/main/CONTRIBUTING.md?ref=mtk"*/}
                {/*                target="_blank"*/}
                {/*                rel="noreferrer"*/}
                {/*                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"*/}
                {/*            >*/}
                {/*                Contribute*/}
                {/*            </a>*/}
                {/*        </li>*/}
                {/*        <li>*/}
                {/*            <a*/}
                {/*                href="https://github.com/creativetimofficial/material-tailwind/blob/main/CODE_OF_CONDUCT.md?ref=mtk"*/}
                {/*                target="_blank"*/}
                {/*                rel="noreferrer"*/}
                {/*                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"*/}
                {/*            >*/}
                {/*                Code of Conduct*/}
                {/*            </a>*/}
                {/*        </li>*/}
                {/*        <li>*/}
                {/*            <a*/}
                {/*                href="https://creative-tim.com/contact-us?ref=mtk"*/}
                {/*                target="_blank"*/}
                {/*                rel="noreferrer"*/}
                {/*                className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"*/}
                {/*            >*/}
                {/*                Contact Us*/}
                {/*            </a>*/}
                {/*        </li>*/}
                {/*    </ul>*/}
                {/*</div>*/}
              </div>
            </div>
          </div>
          {/*<hr className="my-6 border-gray-300" />*/}
          {/*<div className="flex flex-wrap items-center md:justify-between justify-center">*/}
          {/*    <div className="w-full md:w-4/12 px-4 mx-auto text-center">*/}
          {/*        <div className="text-sm text-gray-700 font-medium py-1">*/}
          {/*            Copyright © {new Date().getFullYear()} Material*/}
          {/*            Tailwind by{' '}*/}
          {/*            <a*/}
          {/*                href="https://www.creative-tim.com?ref=mtk"*/}
          {/*                className="text-gray-700 hover:text-gray-900 transition-all"*/}
          {/*            >*/}
          {/*                Creative Tim*/}
          {/*            </a>*/}
          {/*            .*/}
          {/*        </div>*/}
          {/*    </div>*/}
          {/*</div>*/}
        </div>
      </footer>
    </>
  );
}
